import { BaseViewStore } from "core/stores";
import { ConfirmingReportItemValidationService } from "application/confirming-report/services";
import { action, observable } from "mobx";
import { toDate } from "core/utils";
import _ from "lodash";

class ConfirmingReportItemValidationsModalViewStore extends BaseViewStore {
    @observable accessor confirmingReportItemValidations = [];
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.modalParams = componentProps.modalParams;
        this.confirmingReportItemValidationService = new ConfirmingReportItemValidationService(rootStore.application.baasic.apiClient);
        const confirmingReportId = componentProps.modalParams.data.confirmingReportId;
        const salesOrderNumber = componentProps.modalParams.data.salesOrderNumber;
        const patientFullName = componentProps.modalParams.data.patientFullName;
        this.confirmingReportId = confirmingReportId;
        this.salesOrderNumber = salesOrderNumber;
        this.patientFullName = patientFullName;
        this.brightreeBaseUrl = rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl;
        fetch([this.find(salesOrderNumber, confirmingReportId)]);
    }

    @action.bound
    async find(salesOrderNumber, confirmingReportId) {
        const response = await this.confirmingReportItemValidationService.find({
            embed:"CoreUser,Validation,ConfirmingReportItem",
            confirmingReportId: confirmingReportId,
            salesOrderNumber: salesOrderNumber,
            rpp: 1000
        });
        const confirmingReportItemValidations = response.data.item.map(i => {
            return {
                ...i,
                itemId: i.confirmingReportItem && i.confirmingReportItem.itemId,
                itemName: i.confirmingReportItem && i.confirmingReportItem.itemName,
                dateResolved: i.dateResolved ? toDate(i.dateResolved) : null
            };
        });

        this.confirmingReportItemValidations = _.sortBy(confirmingReportItemValidations, 'itemId');
    }

    onChange(confirmingReportItemValidation) {
        confirmingReportItemValidation.isResolved = !confirmingReportItemValidation.isResolved;
    }

    @action.bound
    async updateValidations() {
        try {
            const validations = this.confirmingReportItemValidations.map(validation => validation);

            await this.confirmingReportItemValidationService.updateValidations(validations);

            this.rootStore.notificationStore.success("Validations successfully resolved.");
            await this.modalParams.data.fetchTable();
            this.modalParams.close();
        }
        catch (err) {
            this.rootStore.notificationStore.error("An error ocurred while trying to resolve validations.");
        }
    }

}

export default ConfirmingReportItemValidationsModalViewStore;
